import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NoMouseScrollDirective } from "./no-mouse-scroll.directive";




@NgModule({
  declarations: [NoMouseScrollDirective],
  imports: [
    CommonModule
  ],
  exports: [NoMouseScrollDirective]
})
export class NoMouseScrollModule { }
